import { C, STROKE, Figure, Label, ThermostatValve, arrow } from './figureStyle';

const ID = 'fig-fjernvarme';

export default function FjernvarmeKredsFigure() {
  return (
    <Figure
      id={ID}
      height={240}
      title="Fjernvarmeunit, der sender varmt fremløb gennem termostatventilen til radiatoren, som afgiver varme til rummet og sender afkølet retur tilbage til unitten."
      caption="Fjernvarmesystemets princip: vandet skal afkøles grundigt i radiatorens højde, så det sendes koldt tilbage til værket."
      defs={
        <linearGradient id={`${ID}-fill`} gradientUnits="userSpaceOnUse" x1="0" y1="64" x2="0" y2="210">
          <stop offset="0" stopColor={C.rust} stopOpacity="0.5" />
          <stop offset="0.5" stopColor={C.light} />
          <stop offset="1" stopColor={C.line} />
        </linearGradient>
      }
    >
      {/* Fjernvarmeunit */}
      <rect x="10" y="50" width="86" height="160" rx="6" fill={C.light} stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Varmt fremløb gennem termostatventilen */}
      <line x1="96" y1="80" x2="184" y2="80" stroke={C.rust} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'hot')} />
      <line x1="213" y1="80" x2="226" y2="80" stroke={C.rust} strokeWidth={STROKE.outline} />
      <ThermostatValve cx={200} pipeY={80} />

      {/* Radiator: varm i toppen, kølig i bunden */}
      <rect x="226" y="64" width="120" height="146" rx="6" fill={`url(#${ID}-fill)`} stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Varme til rummet */}
      {[266, 306].map((x) => (
        <line key={x} x1={x} y1="56" x2={x} y2="34" stroke={C.rust} strokeWidth={STROKE.secondary} markerEnd={arrow(ID, 'hot')} />
      ))}

      {/* Afkølet retur tilbage til unitten */}
      <line x1="226" y1="194" x2="100" y2="194" stroke={C.grey} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'cold')} />

      {/* Labels */}
      <Label x={53} y={36} anchor="middle" lines={['Fjernvarmeunit']} />
      <Label x={146} y={108} anchor="middle" lines={['Varmt fremløb']} />
      <Label x={161} y={222} anchor="middle" lines={['Afkølet retur']} />
      <Label x={286} y={140} anchor="middle" lines={['Radiator']} />
      <Label x={356} y={24} anchor="end" kind="note" lines={['Varme afgives til rummet']} />
    </Figure>
  );
}
